import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CustomerState {
    login: boolean
}

const initialState: CustomerState = {
    login: false,
};

const customerSlice = createSlice({
    name: "customer",
    initialState,
    reducers: {
        setRegisteredLogin: (state, action: PayloadAction<boolean>) => {
            state.login = action.payload;
        },
    },
});

export const { setRegisteredLogin } = customerSlice.actions;
export const customerReducer = customerSlice.reducer;
